var r=function(r){return null!=r&&""!==r&&!isNaN(Number(r.toString()))};export{r as default};
